export default __webpack_public_path__ + "static/media/solar-housesM@2x.7227932b.png";